import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-wallet',
    templateUrl: './wallet.component.html',
    styleUrls: ['./wallet.component.scss'],
    standalone: false
})
export class WalletComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
  }


}
